/**
 *
 * @param path
 */
export function publicAssetUrl(path: string) {
  const relativePath = path.startsWith('/') ? path.slice(1) : path
  return new URL(
    `${import.meta.env.BASE_URL}${relativePath}`,
    window.location.origin
  ).href
}
